export const DEFAULT_DEVICE_LOCATION = {
  id: -1,
  country_code: "",
  latitude: 1,
  longitude: 1,
  name: "Your Current Location",
  timezone: "",
  isDeviceLocation: true
};

export interface GeoLocationByPlace {
  id: number,
  name: string,
  latitude: number,
  longitude: number,
  country_code: string,
  timezone: string,
  country?: string,
  admin1?: string,
  admin2?: string,
  admin3?: string,
  admin4?: string,
  isDeviceLocation: boolean,
}

export interface GeoLocationByIpAddress {
  ip: string,
  city: string,
  region: string | null,
  region_code: string | null,
  country_name: string | null,
  country_code: string | null,
  latitude: number | null,
  longitude: number | null,
  utc_offset: string | null,
}

